import React from "react";
import PropTypes from "prop-types";

const ArrowBottomRight = ({ className, color }) => {
  switch (color) {
    case `bone`:
      color = `#f4eee3`;
      break;

    default:
      break;
  }

  //

  return (
    <svg className={className} viewBox="0 0 31.11 29.86">
      <g id="Layer_5" data-name="Layer 5">
        <path
          d="M0,1.28A9.6,9.6,0,0,1,2.53.94a10,10,0,0,1,10,10v1.39a10.91,10.91,0,0,0,10.9,10.9h4.53l1.31,0a13.44,13.44,0,0,0-5.18,5.92l0,.1.67.67.09-.21A12.08,12.08,0,0,1,31,23.2l.05,0,0,0v-.87h0l0,0-.15-.07a12.13,12.13,0,0,1-6.2-6.5l-.09-.21-.67.68,0,.1a13.37,13.37,0,0,0,5.15,6l-1.25,0H23.39a10,10,0,0,1-10-10V10.9A10.91,10.91,0,0,0,2.53,0,10.56,10.56,0,0,0,0,.31Z"
          stroke={color}
        />
      </g>
    </svg>
  );
};

ArrowBottomRight.defaultProps = {
  className: ``,
  color: `#ffffff`
};

ArrowBottomRight.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string
};

export default ArrowBottomRight;
